// extracted by mini-css-extract-plugin
module.exports = {"invoiceLink":"styles_invoiceLink__1fKXY"};